<template> 
  <section class="hero is-fullheight-with-navbar about-page">
    <b-loading :active="isLoading" @update:active="isLoading = $event"></b-loading>
    <div class="hero-body">
      <div class="container">
        <div class="about-card">
          <div class="about-copy">
            <span class="about-eyebrow"></span>
            <img class="about-logo" alt="MyIndústria" src="../assets/logo.png">
            <h1>Operação clara do pedido à produção.</h1>
            <p>Centralize clientes, orçamentos, pedidos e acompanhamento produtivo em uma experiência simples e consistente.</p>
            <div class="about-version">
              <span class="tag is-dark">{{$t('SOBRE.VERSAO')}} {{config.releaseNumber}}</span>
              <span class="tag is-info is-light">{{config.releaseDate}}</span>
            </div>
          </div>
          <div class="about-visual" aria-hidden="true">
            <span class="about-orbit about-orbit-one"></span>
            <span class="about-orbit about-orbit-two"></span>
            <div class="about-symbol"><b-icon icon="factory" size="is-large"></b-icon></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.about-page {
    min-height: calc(100vh - 3.25rem);
    background:
        radial-gradient(circle at 85% 20%, rgba(32, 164, 155, 0.13), transparent 28%),
        var(--surface-page);
}
.about-card {
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(280px, 0.65fr);
    overflow: hidden;
    border: 1px solid var(--border-soft);
    border-radius: 22px;
    background: #fff;
    box-shadow: var(--shadow-md);
}
.about-copy {
    padding: clamp(2rem, 6vw, 5rem);
}
.about-eyebrow {
    color: var(--brand-teal-600);
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.14em;
}
.about-logo {
    display: block;
    width: min(100%, 520px);
    max-height: 220px;
    margin: 1rem 0;
    object-fit: contain;
    object-position: left center;
}
.about-copy h1 {
    max-width: 580px;
    color: var(--text-strong);
    font-size: clamp(1.75rem, 4vw, 2.8rem);
    font-weight: 800;
    line-height: 1.1;
}
.about-copy > p {
    max-width: 600px;
    margin-top: 1rem;
    color: var(--text-muted);
    font-size: 1.05rem;
}
.about-version {
    display: flex;
    gap: 0.5rem;
    margin-top: 1.5rem;
}
.about-visual {
    position: relative;
    display: grid;
    min-height: 420px;
    overflow: hidden;
    place-items: center;
    background: linear-gradient(145deg, var(--brand-navy-900), var(--brand-navy-700));
}
.about-symbol {
    position: relative;
    z-index: 2;
    display: grid;
    width: 110px;
    height: 110px;
    place-items: center;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    box-shadow: 0 20px 45px rgba(3, 23, 40, 0.3);
    transform: rotate(-6deg);
}
.about-orbit {
    position: absolute;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 50%;
}
.about-orbit-one {
    width: 310px;
    height: 310px;
}
.about-orbit-two {
    width: 470px;
    height: 470px;
}
@media (max-width: 768px) {
    .about-page .hero-body {
        padding: 1rem;
    }
    .about-card {
        grid-template-columns: 1fr;
    }
    .about-copy {
        padding: 2rem;
    }
    .about-visual {
        min-height: 210px;
    }
}
</style>

<script>
    import http from '@/http'
    import { mapState } from 'vuex'
    import modalNotificacao from '@/components/modalNotificacao.vue'    

    export default {

      data() {
            return {
              bloquearUsuarioMenu:false,
              listaAtrasados:[],
              isLoading:false,
            }
        },      
        computed: {
            ...mapState([
                'unidadeId',
                'config',
                'usuario',
                'componentes'
            ]),
        },

        methods:{
        
 
          abrirModalNotificacao() {

                const existingModal = document.querySelector('.modal'); 
                if(!existingModal){
                  this.$buefy.modal.open({
                        parent: this,
                        component: modalNotificacao,                                                      
                        hasModalCard: true,
                        trapFocus: true,                    
                        canCancel: false
                    })              

                }            
            
          },

          loadTotalNotificacoesFuncionario() {
      
              http.get('/api/notificacao/retornaTotalNotificacoesFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                      .then(res => res.data)
                      .then(data => {     
                                                      
                      if(data>0)
                        this.abrirModalNotificacao();
                  })
                  .catch((error) => {                        
                      throw error
                  });                            
                                                                
          }, 
      
                                 
        },
        mounted() {                        
            this.loadTotalNotificacoesFuncionario();
          

        },

        
             
    }
</script>
